import { render, staticRenderFns } from "./AppAdd.vue?vue&type=template&id=cb2f94ea&"
import script from "./AppAdd.vue?vue&type=script&lang=js&"
export * from "./AppAdd.vue?vue&type=script&lang=js&"
import style0 from "./AppAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports